import {RhfTextField} from "mui-rhf-integration";
import type * as React from "react";
import type {Control, FieldPath, FieldValues} from "react-hook-form";
import {MenuItem, type SxProps} from "@mui/material";

type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
    label: string;
    control: Control<TFieldValues>;
    name: TName;
    startYear: number;
    endYear: number;
    sx: SxProps;
};

const YearSelectorField = <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
    {
        name,
        label,
        control,
        startYear,
        endYear,
        sx,
    }: Props<TFieldValues, TName>
): React.ReactNode => {
    const years = [];

    for (let year = startYear; year <= endYear; year++) {
        years.push(<MenuItem key={`select-year-${year}`} value={`${year}`}>{year}</MenuItem>)
    }

    return <RhfTextField
        select
        control={control}
        name={name}
        label={label}
        variant="outlined"
        sx={sx}
    >
        {years}
    </RhfTextField>
}

export default YearSelectorField;

